// localStorage keys are per camp (campsez.reports.<campCode>.<name>), so a super director's views
// and layout don't leak between camps. No camp code: null, which usePersistentState keeps in memory.
export const reportStorageKey = (campCode, name) => (campCode ? `campsez.reports.${campCode}.${name}` : null);
